"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _crossPlatformComponents = require("@airasia/cross-platform-components");

var styles = _crossPlatformComponents.StyleSheet.create({
  searchView: {
    backgroundColor: '#F8F8F8',
    borderRadius: 0,
    minHeight: 50,
    maxWidth: 1224,
    width: '100%',
    margin: 'auto'
  },
  form: {
    backgroundColor: '#F8F8F8',
    borderRadius: 0,
    zIndex: 14,
    web: {
      paddingTop: 30,
      paddingBottom: 6
    }
  },
  focusedForm: {
    // This value is to get over the UHF in hotels page
    zIndex: 15
  },
  input: {
    flex: 1
  },
  occupancy: {
    marginRight: 16
  },
  button: {
    paddingVertical: 0
  },
  calendar: {
    zIndex: 1
  },
  focusedInput: {
    zIndex: 3
  },
  overlay: {
    web: {
      position: 'fixed',
      overflowY: 'auto',
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 2,
    flex: 1,
    android: {
      elevation: 0
    }
  }
});

var _default = styles;
exports["default"] = _default;